module.exports = __webpack_public_path__ + "img/sweden-cancer-female.217d9098.png";